export default "__VITE_PUBLIC_ASSET__0f681cf6__"